import Rest from '../Base/Rest';

/**
 * @typedef {CompanyGroupService}
 */
export default class CompanyGroupService extends Rest {
	/**
	 * @type {String}
	 */
	static resource = '/companygroup';
}
